import { api } from './api';

export interface TranscribeResult {
  text: string;
}

/**
 * Upload a recorded audio blob for transcription. Uses the regular `api`
 * instance (30s timeout is enough — clips are <=20s); pass an AbortSignal
 * so a stale request can be cancelled if the user sends/navigates away.
 */
export const voiceApi = {
  async transcribe(blob: Blob, filename: string, signal?: AbortSignal): Promise<TranscribeResult> {
    const form = new FormData();
    form.append('audio', blob, filename);
    const resp = await api.post<TranscribeResult>('/voice/transcribe', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      signal,
    });
    return resp.data;
  },
};
